<template>
  <font-awesome-icon
    icon="bullhorn"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons'

library.add(faBullhorn)

export default {
  name: 'CoozzyBullhornIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
